import '@vfde-brix/multidivider/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';
import '@vfde-brix/promo-price/dist/styles.css';
import { createMultidividerComponent } from '@vfde-brix/multidivider';

import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('brix-multidivider');

for (let i = 0, x = elements.length; i < x; i += 1) {

    const containerElement = elements[i].parentElement;
    createMultidividerComponent(containerElement, NO_PATTERN_BUSINESS_LOGIC);

}
